import React, { FunctionComponent } from 'react';

type ContentCardProps = {
  id: number;
  title: string;
  companyName: string;
  companyIcon: string;
  image: string;
  type: 'recruitment' | 'event';
};

export const Presentation: FunctionComponent<ContentCardProps> = ({
  id,
  title,
  companyName,
  companyIcon,
  image,
  type
}) => {
  const linkUrl = type === 'recruitment'
    ? `/recruitments/${id}`
    : `/events/${id}`;

  const dataValue = type === 'recruitment'
    ? 'related_recruitments'
    : 'related_events';

  return (
    <div className="p-related-articles__item">
      <article className="c-related-article-card">
        <a
          href={linkUrl}
          className="c-related-article-card__link gtm-recruitment-view-count"
          data-recruitment-id={type === 'recruitment' ? id : undefined}
          data-event="click"
          data-category="eventcontent"
          data-value={dataValue}
        >
          <div className="c-related-article-card__inner">
            {image ? (
              <div
                className="c-related-article-card__img"
                style={{ backgroundImage: `url('${image}')` }}
              />
            ) : (
              <div className="c-related-article-card__no-img" />
            )}
            <div className="c-related-article-card__heading">
              <span className="c-related-article-card__icon-img">
                <img src={companyIcon} alt="企業のロゴ写真" />
              </span>
              <h3 className="c-related-article-card__company-name">
                {companyName}
              </h3>
            </div>
            <p className="c-related-article-card__title">
              {title}
            </p>
          </div>
        </a>
      </article>
    </div>
  );
};
